import { inject, provideAppInitializer } from '@angular/core';
import { NotificationNavigationService } from '../services/notification-navigation';
import { parseDeepLinkRaw } from '../helpers/push-payload';
import { isPublicShareEntry } from '../helpers/public-routes';
import { ConfigService } from '../services/config';

const SW_MESSAGE_TYPE = 'AURRICA_DEEP_LINK';

/**
 * Wires service-worker push clicks and cold-start deep links into the Angular router.
 */
export function providePushNotificationBootstrap() {
  return provideAppInitializer(() => {
    const navigation = inject(NotificationNavigationService);
    const { features } = inject(ConfigService);

    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
        if (event.data?.type !== SW_MESSAGE_TYPE) {
          return;
        }
        const raw = event.data?.deepLink;
        if (raw) {
          void navigation.navigateWithDeepLinkData(raw);
        }
      });
    }

    // A pending deep link waits for the app's next load: following it now would take a
    // share-link viewer off the public page. A notification click (above) is deliberate.
    if (isPublicShareEntry(window.location.pathname, features)) {
      return;
    }

    navigation.consumePendingDeepLink();

    const params = new URLSearchParams(window.location.search);
    const pending = params.get('pendingDeepLink');
    if (pending) {
      const parsed = parseDeepLinkRaw(decodeURIComponent(pending));
      window.history.replaceState({}, '', window.location.pathname);
      if (parsed) {
        void navigation.navigateWithDeepLinkData(parsed);
      }
    }
  });
}

export { SW_MESSAGE_TYPE };
